import { ITrendPoint } from './index';

export const prepareSeries = (data: ITrendPoint[]) => {
  return data.map((point) => {
    return {
      y: point.overall,
      interviews: point.surveys
    }
  })
}
export const prepareCategories = (data: ITrendPoint[]) => {
  return data.map((point) => {
    return {
      y: point.overall,
      interviews: point.surveys
    }
  })
}

export const buildHTMLSubtitle = (
  overall: string,
  net: string,
  netColor: string,
  avidLabel: string,
  surveyLabel: string,
  periodLabel: string,
  questionLabel: string,
  segment: string,
  segmentCategory: string,
  questionAbbr: string,
  questionId: string,
  questionValue: string,
  questionSmallText: string,
  drillToDrilldown: boolean,
  renderNetValue: boolean
) => {
  let segmentFragment = '';
  if (segment.length) {
    segmentFragment = ` | <small class="center-align">${segmentCategory}: ${segment}</small>`;
  }
  let netValue = ``;
  if (renderNetValue) {
    netValue = ` <small><span style="color: ${netColor} !important">(${net}%)</span></small>`;
  }
  if (drillToDrilldown) {
    return `
  <h5 class="center-align link" onclick="satisfactionDrill('${questionAbbr}', 'drilldown', '${questionId}', '${questionValue}', '${questionLabel}', '${questionSmallText}');">${overall}%${netValue}</h5>
  <small class="center-align">${avidLabel}</small> | <small class="center-align">${surveyLabel}</small> | <small class="center-align">${periodLabel}</small>${segmentFragment} | <small class="center-align">${questionLabel}</small>
`;
  } else {
    return `
    <h5 class="center-align link" >${overall}%${netValue}</h5>
  <small class="center-align">${avidLabel}</small> | <small class="center-align">${surveyLabel}</small> | <small class="center-align">${periodLabel}</small>${segmentFragment} | <small class="center-align">${questionLabel}</small>
    `;
  }
};

export const buildHTMLFiltersSubtitle = (
  avidLabel: string,
  surveyLabel: string,
  periodLabel: string,
  segment: string,
  segmentCategory: string,
) => {
  let segmentFragment = '';
  if (segment && segment.length > 0) {
    segmentFragment = ` <small class="center-align">${segmentCategory}: ${segment}</small> |`;
  }
  return `
  <small class="center-align">${avidLabel}</small> |
  <small class="center-align">${surveyLabel}</small> |
  <small class="center-align">${periodLabel}</small> |
  ${segmentFragment}
  <small class="center-align">All Measures</small>
  <br/><br/><img src="images/compliment_circle.png?v=3.1" /> Compliment / <img src="images/suggestion_circle.png?v=3.1" /> Suggestion / <img src="images/neutral_circle.png?v=3.1" /> Neutral
`;
};
